import { render, staticRenderFns } from "./PurimAddBulkTracking.vue?vue&type=template&id=0d68f92a&"
import script from "./PurimAddBulkTracking.vue?vue&type=script&lang=js&"
export * from "./PurimAddBulkTracking.vue?vue&type=script&lang=js&"
import style0 from "./PurimAddBulkTracking.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports